import React, { useState } from 'react';
import styles from "../css/deleteAccount.module.css";
import { Container, Col, Row, Button, Modal } from 'react-bootstrap';
import Loader from '../components/loader';
import logo from "../assets/images/Logo.jpeg";
import { UserIcon, LockIcon ,CopyrightIcon} from '../assets/icon';
import { toast } from "react-toastify";
import axiosInstance from '../services/baseurl';
import { DeleteUserWithOTP,VerifyDeleteUserWithOTP } from '../services/endpoints';

const DeleteAccount = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [mobileNo, setMobileNo] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [OTP, setOTP] = useState("");
    const [otpSessionDetails, setOtpSessionDetails] = useState("");
    const [isConfirmationModalOpen, setisConfirmationModalOpen] = useState(false)

    const handleMobileNoChange = (e) => {
        setMobileNo(e.target.value.replace(/\D/g, "").slice(0, 10));
        setOTP("");
        setOtpSessionDetails("");
        setOtpSent(false)
    };

    const handleOTPNoChange = (e) => {
        setOTP(e.target.value.replace(/\D/g, "").slice(0, 6))
    }

    const handleSendOTP = () => {
        if (isLoading) return;
        if (!/^\d{10}$/.test(mobileNo)) {
            toast.error("Enter a valid 10-digit mobile number.");
            return;
        }
        setIsLoading(true);
        axiosInstance
            .post(DeleteUserWithOTP, { phone: mobileNo })
            .then((response) => {
                if (response.data.status === "Success") {
                    setOtpSessionDetails(response.data.payload)
                    setOtpSent(true)
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                toast.error(error.response?.data?.message || error.message);
                setIsLoading(false);
            });
    }

    const handleClose = () =>{
        setIsLoading(false)
        setMobileNo("")
        setOtpSent(false)
        setOTP("")
        setOtpSessionDetails("")
        setisConfirmationModalOpen(false)
    }

    const handleOTPVerify = () => {
        if (!otpSent || !otpSessionDetails || !/^\d{6}$/.test(OTP)) {
            toast.error("Request a verification code and enter the 6-digit OTP.");
            return;
        }
        setisConfirmationModalOpen(true)
    }

    const handleDeleteUser = () =>{
        if (isLoading || !otpSent || !otpSessionDetails || !/^\d{6}$/.test(OTP)) return;
        setIsLoading(true);
        axiosInstance
            .post(VerifyDeleteUserWithOTP, { 
                "sessionID": otpSessionDetails ? parseInt(otpSessionDetails) : 0,
                "otp": OTP
              } )
            .then((response) => {
                if (response.data.status === "Success") {
                    setOtpSessionDetails(response.data.payload)
                    setOtpSent(true)
                    toast.success(response.data.message);
                    handleClose()
                } else {
                    toast.error(response.data.message);
                    setisConfirmationModalOpen(false)
                }
                setIsLoading(false);
            })
            .catch((error) => {
                toast.error(error.response ? error.response.data.message : error.message);
                setIsLoading(false);
                setisConfirmationModalOpen(false)
            });
    }

    return (
        <Container fluid className={styles.deleteMainConatianer}>
            {isLoading === true && <Loader />}
            <div className="sidebar-logoContainer">
                <div className={styles.logoContainer}>
                    <img src={logo} alt="logo" className='LandingLogo' />
                </div>
            </div>
            <p className={styles.noteText}><b>Note:</b> Once your account is deleted your data will be lost.We are not responsible for
                any account related infromation.</p>
            <Container>
                <Row>
                    <Col xs={12} md={3} lg={4}></Col>
                    <Col xs={12} md={6} lg={4} className={styles.loginInputContainer}>
                        <label htmlFor="username" className={styles.loginInputLables}>
                            Mobile No
                        </label>
                        <div className={styles.loginInputMain}>
                            <input
                                type="text"
                                id="username"
                                value={mobileNo}
                                onChange={handleMobileNoChange}
                                className={styles.loginInput}
                                placeholder="Enter Mobile No"
                            />
                            <div className={styles.loginInputIconMain}>
                                <UserIcon />
                            </div>
                        </div>
                        <div className={styles.loginButtonContainer}>
                            <Button type="button" className={styles.loginSubmitButton} onClick={handleSendOTP}>
                                Send OTP
                            </Button>
                        </div>
                    </Col>
                    <Col xs={12} md={3} lg={4}></Col>
                    <Col xs={12} md={3} lg={4}></Col>
                    {otpSent &&
                        <Col xs={12} md={6} lg={4} className={styles.loginInputContainer}>
                            <label htmlFor="OTP" className={styles.loginInputLables}>
                                OTP
                            </label>
                            <div className={styles.loginInputMain}>
                                <input
                                    type="text"
                                    id="OTP"
                                    value={OTP}
                                    onChange={handleOTPNoChange}
                                    className={styles.loginInput}
                                    placeholder="Enter OTP"
                                    max={6}
                                />
                                <div className={styles.loginInputIconMain}>
                                    <LockIcon />
                                </div>
                            </div>
                            <div className={styles.loginButtonContainer}>
                                <Button type="button" className={styles.loginSubmitButton} onClick={handleOTPVerify}>
                                    Verify
                                </Button>
                            </div>
                        </Col>}
                    <Col xs={12} md={3} lg={4}></Col>
                </Row>
            </Container>
            <Modal show={isConfirmationModalOpen} onHide={handleClose} centered> 
                <Modal.Header closeButton>
                    <Modal.Title>User Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete your account</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDeleteUser}>
                        yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <div style={{marginTop:40, width:"100%"}}>
                <p style={{ color: "var(--bw-muted)", textAlign: "center",textAlign:"center", }}>
                Copyright <CopyrightIcon /> {new Date().getFullYear()} BUYANDWIN</p>
                </div>
        </Container>
    )
}

export default DeleteAccount;